<template>
    <v-flex class="create-events" v-if="isChapterAdmin">
        <v-flex class="create-events__title">
            <v-container>
                <h2>{{eventFormConstants.CHAPTER_EVENT_PROGRAMMING}}</h2>
                <small class="create-events__desc">{{eventFormConstants.INFO.EVENT_INFO}}</small>
            </v-container>
        </v-flex>
        <v-container>
            <v-form
                data-qe-id="event_form"
                class="create-events__form"
                ref="eventForm"
                v-model="isValidEventForm">
                <v-flex class="create-events__required">{{eventFormConstants.INFO.REQUIRED}}</v-flex>
                <v-layout
                    row
                    wrap
                    class="create-events__row">
                    <v-flex xs6 pr-4>
                        <label class="create-events__label">{{eventFormConstants.CHAPTER_ADMINISTRATOR_NAME}}</label>
                        <v-flex class="form-control">
                            <v-text-field
                                data-qe-id="event_txt_caname"
                                :rules="requiredRule"
                                v-model="event.AdminName"></v-text-field>
                        </v-flex>
                    </v-flex>
                    <v-flex xs6 pl-4>
                        <label class="create-events__label">{{eventFormConstants.CA_EMAIL}}</label>
                        <v-flex class="form-control">
                            <v-text-field
                                data-qe-id="event_txt_camail"
                                :rules="emailRules"
                                v-model="event.AdminEmail"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <v-layout
                    row
                    wrap
                    class="create-events__row">
                    <v-flex xs6 pr-4>
                        <label class="create-events__label">{{eventFormConstants.BEST_TIME_CONTACT}}</label>
                        <v-layout row wrap>
                            <v-flex mr-3 sm2>
                                <v-select
                                    data-qe-id="event_txt_besttime_hh"
                                    placeholder="HH"
                                    autocomplete
                                    attach
                                    :items="hours()"
                                    :rules="[v => !!v || '']"
                                    v-model="event.bestTimeToContactHours"></v-select>
                            </v-flex>
                            <v-flex sm2>
                                <v-select
                                    data-qe-id="event_txt_besttime_mm"
                                    placeholder="MM"
                                    autocomplete
                                    attach
                                    :items="minutes()"
                                    :rules="[v => !!v || '']"
                                    v-model="event.bestTimeToContactMin"></v-select>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 pl-4>
                        <label class="create-events__label">{{eventFormConstants.TIME_ZONE}}</label>
                        <v-flex class="form-control">
                            <v-select
                                data-qe-id="event_dd_tzone"
                                :items="timeZones"
                                autocomplete
                                attach
                                placeholder="Central Standard Time"
                                :rules="requiredRule"
                                v-model="event.bestTimeToContactTimeZone"></v-select>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <v-layout
                    row
                    wrap
                    class="create-events__row">
                    <v-flex xs6 pr-4>
                        <label class="create-events__label">{{eventFormConstants.LAUNCH_DATE}}</label>
                        <v-flex class="form-control create-events__row__select-date">
                            <v-menu
                                :ref="launchDatePickerMenu"
                                data-qe-id="event_launchdate_close_btn"
                                class="calander-icon"
                                :close-on-content-click="false"
                                attach=""
                                :nudge-right="40"
                                lazy
                                v-model="launchDatePickerMenu"
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                                max-width="290px">
                                <v-text-field
                                    height="40"
                                    slot="activator"
                                    data-qe-id="event_txt_launchDate"
                                    v-model="event.eventLaunchDate"
                                    append-icon="far fa-calendar-alt"
                                    color="ypo_cta"
                                    readonly>
                                </v-text-field>
                                <v-date-picker
                                    v-model="event.eventLaunchDate"
                                    :min="new Date().toISOString().substr(0, 10)"
                                    @input="launchDatePickerMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <v-flex class="create-events__check__block" v-if="cventLookup && cventLookup.cventTemplates.length">
                    <v-layout row wrap>
                        <v-flex xs9>
                            <h6>{{eventFormConstants.TEMPLATES}}</h6>
                        </v-flex>
                        <v-flex xs3 text-sm-center>
                            <h6><small>{{eventFormConstants.CONFIG}}</small></h6>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        row
                        wrap
                        class="create-events__check__block__row labels">
                        <v-flex xs9></v-flex>
                        <v-flex xs3>
                            <v-layout>
                                <v-flex data-qe-id="event_cb_guest" class="check_item">{{eventFormConstants.GUESTS}}</v-flex>
                                <v-flex data-qe-id="event_cb_chaptonly" class="check_item">{{eventFormConstants.CHAPT_ONLY}}</v-flex>
                                <v-flex data-qe-id="event_cb_session" class="check_item">{{eventFormConstants.SESSIONS}}</v-flex>
                                <v-flex data-qe-id="event_cb_fees" class="check_item">{{eventFormConstants.FEES}}</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-radio-group class="event-template" data-qe-id="event_radio_group" v-model="event.radios">
                        <v-radio
                            v-for="temp in templates"
                            :key="temp.id"
                            :data-qe-id="`event_rad_${temp.id}`"
                            :value="`${temp.templateName};${temp.description}`"
                            color="ypo_cta">
                            <template v-slot:label>
                                <v-layout
                                    row
                                    wrap
                                    class="create-events__check__block__row">
                                    <v-flex xs9 class="events-check__list">
                                        <strong>{{temp.templateName}}
                                            <span v-if="temp.subDescription">{{temp.subDescription}}</span>
                                        </strong>
                                        <small>{{temp.description}}</small>
                                    </v-flex>
                                    <v-flex xs3>
                                        <v-layout>
                                            <v-flex class="check_item">
                                                <i :class="[temp.isGuests ? 'fas fa-check' : 'fas fa-minus']"></i>
                                            </v-flex>
                                            <v-flex class="check_item">
                                                <i :class="[temp.isChapterOnly ? 'fas fa-check' : 'fas fa-minus']"></i>
                                            </v-flex>
                                            <v-flex class="check_item">
                                                <i :class="[temp.isSessions ? 'fas fa-check' : 'fas fa-minus']"></i>
                                            </v-flex>
                                            <v-flex class="check_item">
                                                <i :class="[!temp.fees ? 'fas fa-minus' : '']"></i>
                                                <span v-if="temp.fees">{{eventFormConstants.FLAT_FEE}}</span>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex class="create-events__relevant">
                    <h6>{{eventFormConstants.ATTACHED_FILES_HEADER}}</h6>
                    <v-layout row wrap>
                        <v-flex xs4>
                            <div class="create-events__relevant__file-upload">
                                <small>{{eventFormConstants.ATTACHED_FILES_LABEL}}</small>
                                <form
                                    ref="fileform"
                                    v-on:drag.stop.prevent
                                    v-on:dragstart.stop.prevent
                                    v-on:dragend.stop.prevent
                                    v-on:dragover.stop.prevent
                                    v-on:dragenter.stop.prevent
                                    v-on:dragleave.stop.prevent
                                    v-on:drop.stop.prevent="onDropFiles"
                                    class="drop-area">
                                    <v-flex class="upload">
                                        <i class="fas fa-image"></i> {{eventFormConstants.DROP_HERE}}
                                        <input type="file" id="browse" ref="ChapterFileControl" data-qe-id="Chapter_screen-shot_browse_link" @change="onFileChange" style="display:none;" multiple accept="image/pdf/doc/png/jpg/jpeg/*" />
                                        <label for="browse"><b>{{eventFormConstants.BROWSE}}</b></label>
                                    </v-flex>
                                </form>
                                <span class="create-events__error-msg">{{fileErrorMessage}} </span>
                            </div>
                        </v-flex>
                        <v-flex xs8 class="create-events__relevant__tiles">
                            <span class="create-events__relevant__tiles__image" v-for="(file,i) in files" :key="i">
                                <small :title="file.name" :data-qe-id="`file-${i}_name`">{{file.name}}</small>
                                <v-btn
                                    icon
                                    :data-qe-id="`chapter_screen-shot_${i}_close`"
                                    @click="removeFile(file,i)">
                                    <v-icon>{{eventFormConstants.CANCEL}}</v-icon>
                                </v-btn>
                            </span>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-layout
                    row
                    wrap
                    class="create-events__row">

                    <v-flex xs6 pr-4>
                        <label class="create-events__label">{{eventFormConstants.EVENT_TITLE}}</label>
                        <v-flex class="form-control">
                            <v-text-field
                                data-qe-id="event_txt_title"
                                :rules="requiredRule"
                                v-model="event.Title"></v-text-field>
                        </v-flex>
                    </v-flex>
                    <v-flex xs6 pl-4>
                        <label class="create-events__label">{{eventFormConstants.EVENT_CHAMP}}</label>
                        <v-flex class="form-control">
                            <v-text-field
                                data-qe-id="event_txt_champ"
                                :rules="requiredRule"
                                v-model="event.Champions"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <v-layout
                    row
                    wrap
                    class="create-events__row">

                    <v-flex xs6 pr-4>
                        <label class="create-events__label">{{eventFormConstants.CHAPTER_SPONS}}</label>
                        <v-flex class="form-control">
                            <v-text-field
                                data-qe-id="event_txt_sponsor"
                                :rules="requiredRule"
                                v-model="event.Sponsors"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    wrap
                    class="create-events__row">

                    <v-flex xs12>
                        <label class="create-events__label">{{eventFormConstants.EVENT_DESC}}</label>
                        <v-flex class="form-control">
                            <v-textarea
                                data-qe-id="event_txt_desc"
                                counter="20000"
                                :rules="maxLengthRule"
                                v-model="event.Description"></v-textarea>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout
                    row
                    wrap
                    class="create-events__row">

                    <v-flex xs6 pr-4>
                        <label class="create-events__label">{{eventFormConstants.EVENT_CAPACITY}}</label>
                        <v-flex class="form-control">
                            <v-text-field
                                data-qe-id=""
                                placeholder="Leave blank if unlimited"
                                v-model="event.Capacity"></v-text-field>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <v-flex class="events_place">
                    <h6>{{eventFormConstants.WHEN}}</h6>
                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs6 pr-4>
                            <label class="create-events__label">{{eventFormConstants.REG_DEAD}}</label>
                            <v-flex class="create-events__row__select-date">
                                <v-menu
                                    :ref="regDatePickerMenu"
                                    data-qe-id="event_regdate_close_btn"
                                    class="calander-icon"
                                    :close-on-content-click="false"
                                    attach=""
                                    :nudge-right="40"
                                    lazy
                                    v-model="regDatePickerMenu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                    max-width="290px">
                                    <v-text-field
                                        height="40"
                                        slot="activator"
                                        data-qe-id="event_txt_regDate"
                                        v-model="event.eventRegDate"
                                        append-icon="far fa-calendar-alt"
                                        color="ypo_cta"
                                        readonly>
                                    </v-text-field>
                                    <v-date-picker
                                        v-model="event.eventRegDate"
                                        :min="new Date().toISOString().substr(0, 10)"
                                        @input="regDatePickerMenu = false">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs6 pr-4>
                            <label class="create-events__label">{{eventFormConstants.SDATE}}</label>
                            <v-layout row wrap>
                                <v-flex sm8>
                                    <v-flex class="create-events__row__select-date">
                                        <v-menu
                                            :ref="startDatePickerMenu"
                                            data-qe-id="event_startdate_close_btn"
                                            class="calander-icon"
                                            :close-on-content-click="false"
                                            attach=""
                                            :nudge-right="40"
                                            lazy
                                            v-model="startDatePickerMenu"
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                            max-width="290px">
                                            <v-text-field
                                                height="40"
                                                slot="activator"
                                                data-qe-id="event_txt_startDate"
                                                v-model="event.eventStartDate"
                                                append-icon="far fa-calendar-alt"
                                                :rules="dateTimeRule"
                                                color="ypo_cta"
                                                @input="dateDiffValidator()"
                                                readonly>
                                            </v-text-field>
                                            <v-date-picker
                                                v-model="event.eventStartDate"
                                                :max="event.eventEndDate"
                                                :min="new Date().toISOString().substr(0, 10)"
                                                @input="startDatePickerMenu = false,dateDiffValidator()">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-flex>
                                <v-flex sm2>
                                    <v-flex ml-3>
                                        <v-select
                                            data-qe-id="event_txt_besttime_hh"
                                            placeholder="HH"
                                            v-model="event.eventStartDateHH"
                                            :items="hours()"
                                            autocomplete
                                            attach
                                            :rules="[v => !!v || '']"
                                            @input="dateDiffValidator()"></v-select>
                                    </v-flex>
                                </v-flex>
                                <v-flex sm2>
                                    <v-flex ml-3>
                                        <v-select
                                            data-qe-id="event_txt_besttime_mm"
                                            placeholder="MM"
                                            v-model="event.eventStartDateMM"
                                            :items="minutes()"
                                            autocomplete
                                            attach
                                            :rules="[v => !!v || '']"
                                            @input="dateDiffValidator()"></v-select>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs6 pl-4>
                            <label class="create-events__label">{{eventFormConstants.EDATE}}</label>
                            <v-layout row wrap>
                                <v-flex sm8>
                                    <v-flex class="create-events__row__select-date">
                                        <v-menu
                                            :ref="endDatePickerMenu"
                                            data-qe-id="event_enddate_close_btn"
                                            class="calander-icon"
                                            :close-on-content-click="false"
                                            attach=""
                                            :nudge-right="40"
                                            lazy
                                            v-model="endDatePickerMenu"
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                            max-width="290px">
                                            <v-text-field
                                                height="40"
                                                slot="activator"
                                                data-qe-id="event_txt_endDate"
                                                v-model="event.eventEndDate"
                                                append-icon="far fa-calendar-alt"
                                                :rules="dateTimeRule"
                                                color="ypo_cta"
                                                @input="dateDiffValidator()"
                                                readonly>
                                            </v-text-field>
                                            <v-date-picker
                                                v-model="event.eventEndDate"
                                                :min="event.eventStartDate ? event.eventStartDate : new Date().toISOString().substr(0, 10)"
                                                @input="endDatePickerMenu = false,dateDiffValidator()">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-flex>
                                <v-flex sm2>
                                    <v-flex ml-3>
                                        <v-select
                                            data-qe-id="event_txt_besttime_hh"
                                            placeholder="HH"
                                            v-model="event.eventEndDateHH"
                                            :items="hours()"
                                            autocomplete
                                            attach
                                            :rules="[v => !!v || '']"
                                            @input="dateDiffValidator()"></v-select>
                                    </v-flex>
                                </v-flex>
                                <v-flex sm2>
                                    <v-flex ml-3>
                                        <v-select
                                            data-qe-id="event_txt_besttime_mm"
                                            placeholder="MM"
                                            v-model="event.eventEndDateMM"
                                            :items="minutes()"
                                            autocomplete
                                            attach
                                            :rules="[v => !!v || '']"
                                            @input="dateDiffValidator()"></v-select>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs6 pr-4>
                            <label class="create-events__label">{{eventFormConstants.TIME_ZONE}}</label>
                            <v-flex class="form-control">
                                <v-select
                                    data-qe-id="event_dd_tzone"
                                    :items="timeZones"
                                    autocomplete
                                    attach
                                    placeholder="Central Standard Time"
                                    :rules="requiredRule"
                                    v-model="event.RegistrationTimeZone"></v-select>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <h6>{{eventFormConstants.WHERE}}</h6>
                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs6 pr-4>
                                <label class="create-events__label">{{eventFormConstants.EVENT_TYPE}}</label>
                        <v-flex mt-2 class="form-control">
                        <v-radio-group class="event-type" data-qe-id="event_radio_group1" :rules="requiredRule" v-model="event.eventType">
                            <v-radio
                                data-qe-id="event_type_opt1"
                                :value="eventType.VIRTUAL"
                                :label="eventType.VIRTUAL"
                                >
                            </v-radio>
                            <v-radio
                                data-qe-id="event_type_opt2"
                                :value="eventType.IN_PERSON"
                                :label="eventType.IN_PERSON"
                                >
                            </v-radio>
                            <v-radio
                                data-qe-id="event_type_opt3"
                                :value="eventType.HYBRID"
                                :label="eventType.HYBRID"
                                >
                            </v-radio>
                        </v-radio-group>
                        </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        row
                        wrap
                        class="create-events__row">

                        <v-flex xs6 pr-4>
                            <label class="create-events__label">{{eventFormConstants.LOC_NAME}}</label>
                            <v-flex class="form-control">
                                <v-text-field data-qe-id="event_txt_loc" v-model="event.Location"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs6 pl-4>
                            <label class="create-events__label">{{eventFormConstants.STREET_ADD}}</label>
                            <v-flex class="form-control">
                                <v-text-field data-qe-id="event_txt_street" v-model="event.StreetAddress"></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs6 pr-4>
                            <label class="create-events__label">{{eventFormConstants.CITY}}</label>
                            <v-flex class="form-control">
                                <v-text-field data-qe-id="event_txt_city" v-model="event.CityStateOrProvince"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs6 pl-4>
                            <label class="create-events__label">{{eventFormConstants.COUNTRY}}</label>
                            <v-flex class="form-control">
                                <v-text-field data-qe-id="event_txt_country" v-model="event.Country"></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs6 pr-4>
                            <label class="create-events__label">{{eventFormConstants.LIFE_LEARN}}</label>
                            <v-flex class="form-control">
                                <v-select
                                    data-qe-id="event_dd_lifelong"
                                    placeholder="Choose your category"
                                    attach
                                    autocomplete
                                    :items="lifelongLearningCategory"
                                    v-model="event.LifeLearn"
                                    :rules="requiredRule"></v-select>
                            </v-flex>
                        </v-flex>
                        <v-flex xs6 pl-4>
                            <label class="create-events__label">{{eventFormConstants.EVENT_SUB_CATEGORY}}</label>
                            <v-flex class="form-control">
                                <v-select
                                    data-qe-id="event_dd_lifelong"
                                    placeholder="Choose your category"
                                    attach
                                    autocomplete
                                    :items="eventSubCategory"
                                    v-model="event.eventSubCategory"
                                    :rules="requiredRule"></v-select>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                </v-flex>
                <v-flex class="audience_block">
                    <h6>{{eventFormConstants.AUDIENCE}}</h6>
                    <v-layout
                        row
                        wrap
                        class="create-events__row">

                        <v-flex xs12>
                            <v-layout row wrap>
                                <v-flex sm3>
                                    <v-checkbox
                                        v-for="aud in audienceSet1"
                                        :key="aud"
                                        :data-qe-id= "aud"
                                        :label="aud"
                                        :value="aud"
                                        color="ypo_cta"
                                        v-model="event.audienceSelected"
                                        :rules="[() => event.audienceSelected.length > 0 || '']"
                                        hide-details></v-checkbox>
                                </v-flex>

                                <v-flex sm3>
                                    <v-checkbox
                                        v-for="aud in audienceSet2"
                                        :key="aud"
                                        :data-qe-id= "aud"
                                        :label="aud"
                                        :value="aud"
                                        color="ypo_cta"
                                        v-model="event.audienceSelected"
                                        :rules="[() => event.audienceSelected.length > 0 || '']"
                                        hide-details></v-checkbox>

                                </v-flex>

                                <v-flex sm3>
                                    <v-checkbox
                                        v-for="aud in audienceSet3"
                                        :key="aud"
                                        :data-qe-id= "aud"
                                        :label="aud"
                                        :value="aud"
                                        color="ypo_cta"
                                        v-model="event.audienceSelected"
                                        :rules="[() => event.audienceSelected.length > 0 || '']"
                                        hide-details></v-checkbox>

                                </v-flex>

                                <v-flex sm3>
                                    <v-checkbox
                                        v-for="aud in audienceSet4"
                                        :key="aud"
                                        :data-qe-id= "aud"
                                        :label="aud"
                                        :value="aud"
                                        color="ypo_cta"
                                        v-model="event.audienceSelected"
                                        :rules="[() => event.audienceSelected.length > 0 || '']"
                                        hide-details></v-checkbox>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex class="optional_events">
                    <h6>{{eventFormConstants.OP_FEATURE}}</h6>
                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs6 pr-4>
                            <label class="create-events__label">{{eventFormConstants.SPEAKER_NAME}}</label>
                            <v-flex class="form-control">
                                <v-text-field data-qe-id="event_txt_speaker_name" v-model="event.SpeakerName"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs6 pl-4>
                            <label class="create-events__label">{{eventFormConstants.SPEAKER_TTILE}}</label>
                            <v-flex class="form-control">
                                <v-text-field data-qe-id="event_txt_speaker_title" v-model="event.SpeakerTitle"></v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-layout
                        row
                        wrap
                        class="create-events__row">
                        <v-flex xs12>
                            <label class="create-events__label">{{eventFormConstants.SPEAKER_BIO}}</label>
                            <v-flex class="form-control">
                                <v-textarea
                                    data-qe-id="event_txt_speaker_bio"
                                    counter="20000"
                                    :rules="maxLengthRule"
                                    v-model="event.SpeakerBio"></v-textarea>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        row
                        wrap
                        class="create-events__row create-events__currency">

                        <v-flex xs pr-4>
                            <label class="create-events__label">{{eventFormConstants.PRICE}}</label>
                            <v-flex class="form-control">
                                <v-text-field
                                    data-qe-id="event_txt_price"
                                    placeholder="Leave blank if free program"
                                    v-model="event.priceToDisplayOnConnect"></v-text-field>
                            </v-flex>
                        </v-flex>
                        <v-flex xs6 pl-4>
                            <label class="create-events__label">{{eventFormConstants.CURRENCY}}</label>
                            <v-flex class="form-control">
                                <v-select
                                    data-qe-id="event_dd_currency"
                                    placeholder="Choose currency type"
                                    attach
                                    autocomplete
                                    :items="currency"
                                    v-model="event.Currency"></v-select>
                                <span class="note">{{eventFormConstants.NOTE}}</span>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        row
                        wrap
                        class="create-events__row">

                        <v-flex xs6 pr-4>
                            <label class="create-events__label">
                                {{eventFormConstants.CANCEL_DETAIL}}
                                <i class="fas fa-pencil-alt" data-qe-id="event_icon_cancel_details" @click="isCancellationEdit=!isCancellationEdit"></i>
                            </label>
                            <v-flex class="form-control">
                                <v-text-field
                                    v-if="isCancellationEdit"
                                    data-qe-id="event_txt_cancel_details"
                                    v-model="event.cancelDetail"
                                    placeholder="Cancellation Details"></v-text-field>
                                <span v-else data-qe-id="event_txt_cancel_details">{{event.cancelDetail}}</span>
                            </v-flex>
                        </v-flex>
                        <v-flex xs6 pl-4>
                            <label class="create-events__label">
                                {{eventFormConstants.DRESS}}
                                <i class="fas fa-pencil-alt" data-qe-id="event_icon_dress" @click="isDressEdit=!isDressEdit"></i>
                            </label>
                            <v-flex class="form-control">
                                <v-text-field
                                    v-if="isDressEdit"
                                    data-qe-id="event_txt_dress"
                                    v-model="event.dressCode"
                                    placeholder="What to wear (Dress Attire)"></v-text-field>
                                <span v-else data-qe-id="event_txt_dress">{{event.dressCode}}</span>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-flex text-xs-right pt-4>
                        <p v-if="!isValidEventForm" class="create-events__error-msg">{{eventFormConstants.VALIDATION.REQUIRED}}</p>
                        <v-btn
                            flat
                            @click="resetEvent()"
                            data-qe-id="event_cancel_btn"
                            class="primary_btn transparent">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            :disabled="!isValidEventForm"
                            :loading="updateInProgress"
                            @click="submitEvent()"
                            data-qe-id="event_post_save_btn"
                            class="primary_btn">
                            {{appCommonConstants.SUBMIT}}
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-form>
        </v-container>
        <v-dialog
            data-qe-id="event_confirmation_popup"
            scrollable
            persistent
            v-model="submissionDialog"
            content-class="small">

            <v-card class="custom-dailog submit_dialog">
                <v-card-title>
                    {{eventFormConstants.INFO.THANK_YOU}}
                </v-card-title>
                <v-card-text class="inner-scrollbar">
                    {{eventFormConstants.INFO.SUBMIT_INFO}}
                </v-card-text>
                <v-card-actions>
                    <v-flex text-xs-right class="pa-3">
                        <v-btn
                            outline
                            data-qe-id="event_create_event_btn"
                            class="primary_btn"
                            @click="createNewChapterEvent()"><i class="fas fa-plus-circle"></i>{{eventFormConstants.CREATE_NEW}}</v-btn>
                        <v-btn
                            class="primary_btn"
                            data-qe-id="event_done_btn"
                            @click="backToChapter()">{{appCommonConstants.DONE}}</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import { appCommonConstants, roles } from "../appCommon.constants";
    import { hours, minutes } from "../../common/utils/hourMinutes";
    import { eventFormConstants, eventType } from "./ChapterEvent.Constants";
    import { mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import moment from "moment";

    export default {
        name: "ChapterEvent",
        components: {},
        data: () => ({
            appCommonConstants,
            hours,
            minutes,
            eventFormConstants,
            lifelongLearningCategory: [],
            currency: [],
            eventSubCategory: [],
            eventType,
            isValidEventForm: false,
            launchDatePickerMenu: false,
            startDatePickerMenu: false,
            endDatePickerMenu: false,
            regDatePickerMenu: false,
            isCancellationEdit: false,
            isDressEdit: false,
            submissionDialog: false,
            files: [],
            fileErrorMessage: '',
            isError: false,
            updateInProgress: false,
            audienceSet1: [],
            audienceSet2: [],
            audienceSet3: [],
            audienceSet4: [],
            timeZones: [],
            templates: [],
            event: {
                AdminName: '',
                AdminEmail: '',
                bestTimeToContactHours: '',
                bestTimeToContactMin: '',
                bestTimeToContactTimeZone: '',
                eventLaunchDate: '',
                radios: '',
                Title: '',
                Champions: '',
                Sponsors: '',
                Description: '',
                Capacity: '',
                eventRegDate: '',
                eventStartDate: '',
                eventStartDateHH: '',
                eventStartDateMM: '',
                eventEndDate: '',
                eventEndDateHH: '',
                eventEndDateMM: '',
                RegistrationTimeZone: '',
                Location: '',
                StreetAddress: '',
                CityStateOrProvince: '',
                Country: '',
                audienceSelected: [],
                SpeakerName: '',
                SpeakerTitle: '',
                SpeakerBio: '',
                priceToDisplayOnConnect: '',
                Currency: '',
                cancelDetail: '',
                dressCode: '',
                eventType: '',
                eventSubCategory: '',
            },

            requiredRule: [v => (!!v && !!(v.trim())) || ''],
            emailRules: [
                v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || eventFormConstants.VALIDATION.INVALID_EMAIL,
            ],
            dateTimeRule: [v => !!v || ''],
            atLeastOneSelected: selected => selected.length > 0 || '',
            maxLengthRule: [v => !v || v.length <= 20000 || ''],
        }),
        created() {
            if (!this.isChapterAdmin) {
                this.$router.push('/home');
            } else {
                this.event.AdminEmail = this.person && this.person.email ? this.person.email : '';
                this.getEventCustomField().then((response) => {
                    if (response.status === 200) {
                        this.eventCustomFieldsInfo = response.data;
                    }
                }).catch((err) => {
                    console.log(err);
                });
                this.getCventLookup().then((response) => {
                    if (response.status === 200) {
                        this.eventInfo = response.data;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            }
        },
        props: {
            maxFileSizeLimit: {
                type: Number,
                default: 100 * (1024 * 1024), // 100MB
            },
        },
        methods: {
            ...mapActions({
                submitChapterEvent: `chapterEvents/${storeAction.submitChapterEvent}`,
                getCventLookup: `chapterEvents/${storeAction.getCventLookup}`,
                getEventCustomField: `chapterEvents/${storeAction.getEventCustomField}`,
            }),
            submitEvent() {
                if (this.$refs.eventForm.validate()) {
                    this.updateInProgress = true;
                    const formData = new FormData();
                    formData.append('ChapterEvent', JSON.stringify(this.event));
                    for (let i = 0; i < this.files.length; i += 1) {
                        formData.append(`Attachments[${i}]`, this.files[i]);
                    }
                    this.submitChapterEvent(formData).then((response) => {
                        this.updateInProgress = false;
                            if (response) {
                                this.resetEvent();
                                window.scrollTo(0, 0);
                                this.submissionDialog = true;
                            }
                        })
                        .catch((err) => {
                            this.updateInProgress = false;
                            console.log(err);
                        });
                }
            },
            resetCalendars(date) {
                setTimeout(() => {
                    this.event.eventLaunchDate = date;
                    this.event.eventRegDate = date;
                    this.event.eventStartDate = date;
                    this.event.eventEndDate = date;
                }, 0);
            },
            resetEvent() {
                if (this.$refs.eventForm) {
                    this.$refs.eventForm.reset();
                    this.files = [];
                    this.resetCalendars(new Date().toISOString().substr(0, 10));
                    this.resetCalendars('');
                }
            },
            backToChapter() {
                this.$router.push({
                    name: 'chapter',
                    path: "/chapter/",
                    params: {
                        communityId: this.$route.params ? this.$route.params.communityId : '',
                        routedFromChapterEvent: true,
                    },
                });
            },
            createNewChapterEvent() {
                this.event.AdminEmail = this.person && this.person.email ? this.person.email : '';
                this.submissionDialog = false;
            },
            dateDiffValidator() {
                if (this.event.eventStartDate &&
                    this.event.eventEndDate &&
                    this.event.eventStartDateHH &&
                    this.event.eventStartDateMM &&
                    this.event.eventEndDateHH &&
                    this.event.eventEndDateMM) {
                    this.dateTimeRule = [v => !!v || ''];
                    const startDate = moment(`${this.event.eventStartDate} ${this.event.eventStartDateHH}:${this.event.eventStartDateMM}`, "YYYY-MM-DD HH:mm");
                    const endDate = moment(`${this.event.eventEndDate} ${this.event.eventEndDateHH}:${this.event.eventEndDateMM}`, "YYYY-MM-DD HH:mm");

                    if (endDate.diff(startDate) < 0) {
                        this.dateTimeRule.push(this.eventFormConstants.VALIDATION.INVALID_DATE);
                    }
                }
            },
            onFileChange(e) {
                const selectedFiles = e.target.files;
                this.uploadFiles(selectedFiles);
            },
            onDropFiles(e) {
                const droppedFiles = e.dataTransfer.files;
                this.uploadFiles(droppedFiles);
            },
            uploadFiles(selectedFiles) {
                this.fileErrorMessage = '';
                this.isError = false;
                if (selectedFiles && selectedFiles.length > 0) {
                    for (let i = 0; i < selectedFiles.length; i += 1) {
                        const browseVal = selectedFiles[i].name.lastIndexOf(".");
                        const browseFilename = selectedFiles[i].name.substring(0, browseVal);
                        if (!this.validateFileNameLength(browseFilename.length)) { // check file name length (max limit 250 char)
                            this.fileErrorMessage = this.eventFormConstants.FILE_NAME_LENGTH_EXCEEDED;
                            this.isError = true;
                        } else if (!this.validateFileType(selectedFiles[i].name)) { // check file types (doc, docx, png, jpg, jpeg, pdf, gif)
                            this.fileErrorMessage = this.eventFormConstants.FILE_NOT_SUPPORTED;
                            this.isError = true;
                        } else if (!this.validateDuplicateName(selectedFiles[i].name)) { // check duplicate file names
                            this.fileErrorMessage = this.eventFormConstants.FILENAME_ALREADY_EXISTS;
                            this.isError = true;
                        } else if (!this.validateFileSize(selectedFiles[i].size)) { // check total file size (max limit 100MB)
                            this.fileErrorMessage = this.eventFormConstants.FILE_SIZE_EXCEEDED;
                            this.isError = true;
                        } else {
                            selectedFiles[i].url = this.imageUrl(selectedFiles[i]);
                            this.files.push(selectedFiles[i]);
                        }
                    }
                }
                if (this.isError) {
                    setTimeout(() => {
                        this.fileErrorMessage = '';
                        this.isError = false;
                    }, this.eventFormConstants.ERROR_MESSAGE_TIMEOUT_SECONDS);
                }
            },
            validateDuplicateName(fileName) {
                let isValid = true;
                if (this.files && this.files.length > 0) {
                    if (fileName && this.files.filter(f => f.name === fileName).length > 0) {
                        isValid = false;
                    }
                }
                return isValid;
            },
            validateFileType(fileType) {
                return new RegExp(this.eventFormConstants.FILETYPES_SUPPORTED.join("|")).test(fileType);
            },
            validateFileNameLength(length) {
                return length && length > 0 && length < this.eventFormConstants.FILENAME_MAX_LIMIT;
            },
            validateFileSize(sizeInBytes) {
                if (this.files && this.files.length > 0) {
                    this.files.forEach((file) => {
                    sizeInBytes += file.size;
                    });
                }
                return sizeInBytes < this.maxFileSizeLimit;
            },
            imageUrl(file) {
                return URL.createObjectURL(file);
            },
            removeFile(imageObj) {
                const index = this.files.findIndex(item => item.name === imageObj.name);
                this.files.splice(index, 1);
                if (this.files.length === 0) {
                    this.fileErrorMessage = '';
                    this.files = [];
                }
            },
        },
        computed: {
            ...mapGetters({
                person: `myAccount/${storeGetters.profileInformation}`,
                getCommunityInfo: `chapter/${storeGetters.communityInfo}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                eventCustomField: `chapterEvents/${storeGetters.eventCustomField}`,
                cventLookup: `chapterEvents/${storeGetters.cventLookup}`,
            }),   
            isChapterAdmin() {
                const cid = this.$route.params ? this.$route.params.communityId.toLowerCase() : '';
                let community = this.getCommunityInfo;
                if (!community && cid) {
                community = this.usersCommunitiesList && this.usersCommunitiesList.length ? this.usersCommunitiesList.find(x => x.communityId.toLowerCase() === cid) : null;
                }
                return community && community.roles && community.roles.some(o => o === roles.CHAPTER_ADMINISTRATOR || roles.TEAM_MEMBER_PRODUCT_MANAGEMENT) &&
                    community.communityId.toLowerCase() === cid;
            },
        },
        watch: {
            person(val) {
                this.event.AdminEmail = val.email ? val.email : '';
            },
            eventCustomField(val) {
                if (val && val.lifelongLearningCategories && val.lifelongLearningCategories.length) {
                    this.lifelongLearningCategory = val.lifelongLearningCategories;
                }
                if (val && val.focusSubCategories && val.focusSubCategories.length) {
                    this.eventSubCategory = val.focusSubCategories;
                }
                if (val && val.currencyCodes && val.currencyCodes.length) {
                    this.currency = val.currencyCodes;
                }
                //Create set of different audiences
                if (val && val.audiences && val.audiences.length) {
                    for (let i = 0; i < 5; i++) {
                        this.audienceSet1.push(val.audiences[i]);
                    }
                    for (let i = 5; i < 10; i++) {
                        this.audienceSet2.push(val.audiences[i]);
                    }
                    for (let i = 10; i < 15; i++) {
                        this.audienceSet3.push(val.audiences[i]);
                    }
                    for (let i = 15; i < 20; i++) {
                        this.audienceSet4.push(val.audiences[i]);
                    }
                }
            },
            cventLookup(val) {
                if (val && val.timeZones && val.timeZones.length) {
                    val.timeZones.forEach((tz) => {
                        this.timeZones.push(tz.timezoneName);
                    });
                }
                if (val && val.cventTemplates && val.cventTemplates.length) {
                    this.templates = val.cventTemplates;
                    // Default Configuration for Event Templates
                    this.templates.forEach((temp) => {
                        if (temp.id === 1 || temp.id === 6 || temp.id === 7) {
                            temp.isGuests = false;
                        } else {
                            temp.isGuests = true;
                        }
                        if (temp.id < 5) {
                            temp.isChapterOnly = true;
                        } else {
                            temp.isChapterOnly = false;
                        }
                        if (temp.id === 5) {
                            temp.isSessions = true;
                        } else {
                            temp.isSessions = false;
                        }
                        if (temp.id === 3 || temp.id === 5) {
                            temp.fees = this.eventFormConstants.FLAT_FEE;
                        } else {
                            temp.fees = null;
                        }
                    });
                }
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .create-events {
        padding-top: 64px;
        height: 100%;
        padding-bottom: 50px;
        background: $white;

        &__title {
            border-bottom: 2px solid rgba($ypo-blue, 0.1);
            padding-bottom: 25px;
            padding-top: 20px;
            margin-bottom: 40px;

            h2 {
                font-weight: 500;
                font-size: 30px;
                color: $ypo-blue;
                font-family: "Raleway", sans-serif;
            }

            small {
                font-family: "Raleway", sans-serif;
                font-size: 12px;
            }
        }

        &__required {
            font-size: 14px;
            color: $ypo_blue;
            font-weight: 600;
            margin-bottom: 20px;
        }

        h6 {
            font-weight: 500;
            font-size: 24px;
            color: $ypo-blue;
            font-family: "Raleway", sans-serif;
            margin-bottom: 25px;
        }

        &__relevant {
            margin-bottom: 45px;

            &__tiles {
                margin-top: 23px;
                padding-left: 10px;

                .v-image__image {
                    background-repeat: no-repeat;
                    height: 80px;
                    max-width: 60px;
                    border-radius: 5px;
                    border: 1px solid rgba(8, 48, 80, 0.4);
                }

                &__image {
                    position: relative;
                    background-color: $ypo-tile-bgcolor;
                    border: 1px solid $ypo-cta;
                    border-radius: 100px;
                    padding: 3px 25px 3px 10px;
                    align-items: center;
                    display: inline-flex;
                    margin: 2px;

                    small {
                        display: block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        margin-right: 5px;
                        font-size: 14px;
                    }

                    .v-btn {
                        position: absolute;
                        padding: 0;
                        width: auto;
                        height: auto;
                        margin: 0;
                        right: 6px;
                        z-index: 1;

                        .v-icon {
                            font-size: 16px;
                            padding-top: 1px;
                            color: $ypo-cta;
                        }
                    }
                }
            }

            &__file-upload {
                small {
                    color: $ypo-dark-background-gray;
                    font-size: 12px;
                }

                form {
                    background-color: $ypo-tile-bgcolor;
                    border: 1px dashed rgba($ypo-blue, 0.3);
                    padding: 30px 20px;
                    border-radius: 3px;
                    margin-top: 5px;
                }

                i {
                    color: $ypo-dark-gray;
                    font-size: 20px;
                    vertical-align: bottom;
                }

                b {
                    color: $ypo-cta;
                }

                &.champion-profile {
                    margin: 0 10px;
                }
            }
        }

        &__check__block {
            margin: 30px 0px 0 0;

            h6 {
                margin-bottom: 10px;

                small {
                    font-size: 14px;
                    font-weight: 600;
                }
            }

            .events-check__list {
                padding-right: 10px;

                strong {
                    display: block;
                    color: $ypo-blue;
                    font-size: 14px;

                    span {
                        color: rgba($ypo-blue, 0.5);
                        font-size: 12px;
                        display: block;
                    }
                }

                small {
                    font-size: 12px;
                    color: $ypo-gray-text;
                    font-weight: 400;
                }
            }

            .v-input--checkbox {
                display: inline-flex;
            }

            .check_item {
                text-align: center;
                width: 25%;

                .fa-minus {
                    color: rgba($ypo-blue, 0.3);
                }

                span {
                    font-size: 10px;
                    line-height: normal;
                    color: rgba($ypo-blue, 0.4);
                    display: inline-block;
                }
            }

            .labels {
                .check_item {
                    background: rgba($ypo-blue, 0.1);
                    font-size: 12px;
                    padding: 10px 0px;
                    border-right: 1px solid rgba($ypo-blue, 0.1);

                    &:last-child {
                        border: none;
                    }
                }
            }

            &__msg {
                color: $ypo-error-red;
                font-size: 12px;
                display: block;
                margin-top: 10px;
                text-align: right;
                padding-right: 13px;
            }

            &__row {
                align-items: center;
            }

        }

        .audience_block {

            .v-input--selection-controls {
                margin-bottom: 10px;

                .v-label {
                    font-size: 12px;
                    font-weight: 500;
                    color: $ypo-gray-text !important;
                }
            }
        }

        .heading {
            background: $ypo-blue;
            padding: 10px;

            h6 {
                font-size: 14px;
                color: $white;
            }
        }

        &__row {
            align-items: center;
            margin-bottom: 20px;

            .v-text-field {
                padding-top: 3px;
            }

            .v-input__slot {
                box-shadow: none !important;

                &::before {
                    border-color: $ypo-medium-gray !important;
                    bottom: 0px !important;
                }
            }

            .error--text {
                .v-input__slot {
                    &::before {
                        border-color: $ypo-error-red !important;
                        z-index: 1;
                    }
                }
            }

            .v-text-field {
                input {
                    border-bottom: 1px solid $ypo-medium-gray;
                    color: $ypo-gray-text !important;
                    font-size: 14px;
                    transition: 0.3s all ease;
                }
            }
            &__select-date {
                .calander-icon {
                    .v-text-field {
                        .v-input__slot {
                            height: 33px !important;
                        }

                        input {
                            border-bottom: 0;
                        }
                    }
                }
            }

            .v-textarea {
                .v-label {
                    font-size: 14px;
                    left: 0px !important;
                }

                .v-input__slot {
                    border-bottom: 1px solid $ypo-medium-gray;
                    border-radius: 0px !important;
                    padding: 0px !important;
                    font-size: 14px;
                }
            }

            .v-select__slot {
                border-bottom: 1px solid $ypo-medium-gray;

                input {
                    border: none;
                }
            }
        }

        &__label {
            font-size: 14px;
            font-weight: 600;
            color: rgba($ypo-blue, 0.8);

            i {
                cursor: pointer;
            }
        }

        .event-template {
            margin-top: 0px;
            padding-top: 0px;

            .v-input__control {
                width: 100%;
            }
            
            .v-radio {
                border: 1.3px solid $ypo-medium-gray;
                margin: 0px 0 10px 0 !important;
                border-radius: 5px;
                position: relative;
                padding: 10px 10px 10px 40px;
                transition: 0.3s all ease;

                &:hover,
                &.ypo_cta--text {
                    background: rgba($ypo-blue, 0.03);
                }

                .v-input--selection-controls__input {
                    position: absolute;
                    left: 10px;
                    top: 11px;
                }

                .v-label {
                    width: 100%;
                }
            }

            .v-input--checkbox {
                .v-input--selection-controls__input {
                    position: relative;
                }
            }
        }

        &__currency {
            align-items: inherit;

            .note {
                font-size: 13px;
            }
        }

        &__error-msg {
            display: inline-flex;
            margin-bottom: 0px;
            color: $ypo-error-red;
        }
        .event-type {
            .v-input--selection-controls__input + .v-label {
                font-weight: normal;
                font-size: 14px;
            }
        }
    }

    .submit_dialog {
        .v-card__title {
            background: $ypo-green !important;
            color: $white !important;
        }

        .v-card__text {
            color: $ypo-blue;
            font-weight: 600;
            font-size: 18px;
            padding: 40px 30px;
            line-height: 28px;
            text-align: center;
        }

        .primary_btn {
            i {
                font-size: 18px;
                margin-right: 10px;
            }
        }
    }
</style>
